import { style } from '@vanilla-extract/css';

const host = style({
  minHeight: '100vh',
});

const column = style({
  maxWidth: '60rem',
  margin: '0 auto',
});

export const css = {
  host,
  column,
};
